// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../../components";
import { withRouter,Link } from "react-router-dom";
import { compose } from "redux";
import { createBrowserHistory } from "history";
import auth from "../../../services/auth";
import Dashboard from "../dashboard";
import MerchantDashboard from "../../merchant/dashboard";
import AffiliateDashboard from "../../affiliate/dashboard";
import SalesDashboard from "../../salesPerson/dashboard";

const history = createBrowserHistory();
let usertype = "";
class Home extends Component {
  componentWillMount() {
    let userid = this.props.match.params.userid
      ? this.props.match.params.userid
      : "";
    usertype = this.props.match.params.usertype
      ? this.props.match.params.usertype
      : "";

    if (userid && usertype == "superadmin") {
      const { dispatch } = this.props;
      this.props.superAdminLogin(userid, usertype);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userResponse.result) {
        usertype = nextProps.userResponse.result.userTypeName;
    }
  }

  render() {
    let dashboard;
        if (usertype == "superadmin") {
          dashboard = <Dashboard />;
        } else {
          let userinfo = auth.getUserInfo();
    
          if (userinfo.userTypeName == "merchant") {
            dashboard = <MerchantDashboard />;
          } else if (userinfo.userTypeName == "affiliate") {
            dashboard = <AffiliateDashboard />;
          } else if (userinfo.userTypeName == "salesmanager") {
            dashboard = <SalesDashboard />;
          } else {
            dashboard = <Dashboard />;
          }
        }
  
    return <AnimatedView>{dashboard}</AnimatedView>;
  }
}

export default compose(withRouter)(Home);



// WEBPACK FOOTER //
// ./src/app/views/admin/home/Home.js